export const GET_ONCALL_TEAMS = "GET_ONCALL_TEAMS";
export const DELETE_TEAM = "DELETE_TEAM";
export const CREATE_TEAM = "CREATE_TEAM";
export const UPDATE_TEAM = "UPDATE_TEAM";
export const ERR_CATCH = "ERR_CATCH";
export const SET_ALIAS = "SET_ALIAS";



// WEBPACK FOOTER //
// ./src/actions/types.js